import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  validateLink,
  validatePassCode,
  getActionData,
  expireOnTime,
  sendPassCode,
  setStatus,
  isConfirmationCompleted,
  isRequestActive,
  validatePaans
} from "AuthorizeLink/actions";
import {
  selectActionData,
  selectValidLink,
  selectValidPassCodeLink,
  selectPaansCheck,
  sendPassCodeRes,
  selectStatus,
  selectConfirmationIsCompleted,
  selectSettings,
  selectRequestActive
} from "AuthorizeLink/selectors";


import RFELinkExpiredContent from "../RFELinkExpired/RFELinkExpiredContet";
import MagicLinkAuthentication from "AuthorizeLink/components/MagicLinkAuthentication";
import RFEPassCodeAuthentication from "AuthorizeLink/components/RFEPassCodeAuthentication";
import MagicActionValidationRequest from "contracts/requests/MagicActionValidationRequest";
import PassCodeActionValidationRequest from "contracts/requests/PassCodeActionValidationRequest";
import AUTHORIZE_STATUS from "AuthorizeLink/constants/status";
import _ from "lodash";
import { Redirect } from "react-router";
import config from "config";

const mapStateToProps = state => {
  return {
    actionData: selectActionData(state),
    validLink: selectValidLink(state),
    validPassCode: selectValidPassCodeLink(state),
    paansCheck: selectPaansCheck(state),
    sendPassCodeRes: sendPassCodeRes(state),
    status: selectStatus(state),
    ConfirmationCompleted: selectConfirmationIsCompleted(state),
    settings: selectSettings(state),
    requestActive: selectRequestActive(state)
  };
};
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      validateLink: magicActionValidationRequest =>
        validateLink(magicActionValidationRequest),
      validatePaans: passCodeActionValidationRequest =>
        validatePaans(passCodeActionValidationRequest),
      validatePassCode: passCodeActionValidationRequest =>
        validatePassCode(passCodeActionValidationRequest),
      getActionData: actionKey => getActionData(actionKey),
      expireOnTime: actionKey => expireOnTime(actionKey),
      sendPassCode: magicActionValidationRequest =>
        sendPassCode(magicActionValidationRequest),
      setStatus: status => setStatus(status),
      isConfirmationCompleted: link => isConfirmationCompleted(link),
      isRequestActive: link => isRequestActive(link)
    },
    dispatch
  );
class Authorize extends React.Component {
  static propTypes = {
    status: PropTypes.number,
    actionData: PropTypes.object,
    validLink: PropTypes.object,
    validPassCode: PropTypes.object,
    paansCheck: PropTypes.object,
    actionKey: PropTypes.string,
    validateLink: PropTypes.func,
    validatePassCode: PropTypes.func,
    getActionData: PropTypes.func,
    expireOnTime: PropTypes.func,
    sendPassCode: PropTypes.func,
    generateValidation: PropTypes.func,
    setStatus: PropTypes.func,
    isExpired: PropTypes.bool,
    ConfirmationCompleted: PropTypes.bool,
    isConfirmationCompleted: PropTypes.func,
    settings: PropTypes.object,
    isRequestActive: PropTypes.func,
    requestActive: PropTypes.string,
    validatePaans: PropTypes.func
  };
  constructor(props) {
    super(props);
    this.state = {
      isReadyToValidate: false,
      emailValue: false,
      showErrorWrap: false
    };
  }
  async componentDidMount() {
    const {
      isConfirmationCompleted,
      getActionData,
      isRequestActive
    } = this.props;

    await isConfirmationCompleted(this.props.actionKey);
    await isRequestActive(this.props.actionKey);
    await getActionData(this.props.actionKey);
  }

  isEmptyValues = value => {
    const isEmpty =
      value === undefined ||
      value === null ||
      value === NaN ||
      (typeof value === "object" && Object.keys(value).length === 0) ||
      (typeof value === "string" && value.trim() === "");
    return isEmpty;
  };

  shouldComponentUpdate(nextProps) {
    var cryptoJS = require("crypto-js");
    var words = "";
    var encryptedKey = "";

    if (nextProps.status !== this.state.status && nextProps.status > 0) {
      this.init(nextProps.status);
      return true;
    }
    if (nextProps.isRequestActive !== this.props.isRequestActive) return true;

    if (
      !_.isEmpty(nextProps.validLink) &&
      this.state.status == AUTHORIZE_STATUS.AUTHORIZE
    ) {
      this.validLink(nextProps.validLink);
      return true;
    }

    if (
      !_.isEmpty(nextProps.validPassCode) &&
      nextProps.validPassCode.valid && 
      !nextProps.validPassCode.expired &&
      this.state.status == AUTHORIZE_STATUS.AUTHORIZED
    ) {
      if (_.isEmpty(nextProps.paansCheck) &&
          !this.isEmptyValues(nextProps.validPassCode) &&
          !this.isEmptyValues(nextProps.validPassCode.sessionHash) &&
          !this.isEmptyValues(nextProps.validPassCode.sessionId)   
      ){     
        words = cryptoJS.enc.Utf8.parse(this.props.validLink.decryptKey);
        encryptedKey = cryptoJS.enc.Base64.stringify(words);

        const request_validatepaans = {
          actionKey: this.props.actionKey,
          decryptKey: encryptedKey,
          sessionId: nextProps.validPassCode.sessionId,
          sessionHash: nextProps.validPassCode.sessionHash
        }

        this.props.validatePaans(request_validatepaans);    
      }
      else if (
        !_.isEmpty(nextProps.paansCheck) &&
        !nextProps.paansCheck.hasAccepted
      ) {
        /* if redirect url is not empty in the paans reponse */
        window.location.href =
          config.paans.checkAPILink + nextProps.paansCheck.redirectUrl;
      } else if (
        !_.isEmpty(nextProps.paansCheck) &&
        !this.isEmptyValues(nextProps.validPassCode) &&
        !this.isEmptyValues(nextProps.validPassCode.sessionHash) &&
        !this.isEmptyValues(nextProps.validPassCode.sessionId)
      ) {
        /* redirecting normally to RFE File upload page */
        words = cryptoJS.enc.Utf8.parse(nextProps.validLink.decryptKey);
        encryptedKey = cryptoJS.enc.Base64.stringify(words);

        window.location.href = `${nextProps.validLink.redirectURL}${
          nextProps.actionKey
        }/${encryptedKey}/${
          nextProps.validPassCode.sessionId
        }/${nextProps.validPassCode.sessionHash}`;
      }
    }
    return false;
  }
  getSteps = () => {
    const steps = [
      {
        statusId: AUTHORIZE_STATUS.AUTHORIZE,
        ActiveComponent: React.createFactory(MagicLinkAuthentication),
        props: {
          handleValidate: this.handleValidate
        }
      },
      {
        statusId: AUTHORIZE_STATUS.AUTHORIZED,
        ActiveComponent: React.createFactory(RFEPassCodeAuthentication),
        props: {
          handlePassCodeValidate: this.handlePassCodeValidate,
          handleSendPassCode: this.handleSendPassCode
        }
      },
      {
        statusId: AUTHORIZE_STATUS.EXPIRED,
        ActiveComponent: React.createFactory(RFELinkExpiredContent),
        props: {}
      }
    ];
    return steps;
  };
  init = statusId => {
    const steps = this.getSteps();
    const stepComponent = steps.find(item => {
      return item.statusId == statusId;
    });

    if (stepComponent) {
      if (this.validAction(statusId)) {
        this.setState({
          ...this.state,
          stepComponent: stepComponent,
          status: statusId
        });
      }
    } else {
      this.setState({
        ...this.state,
        stepComponent: null
      });
    }
  };
  validAction = status => {
    const { actionData } = this.props;
    switch (status) {
      case AUTHORIZE_STATUS.AUTHORIZE:
        if (!_.isEmpty(actionData)) {
          if (_.isEmpty(actionData.name)) {
            this.setState({ redirectNotFound: true });
          } else {
            return true;
          }
        } else {
          this.setState({ redirectNotFound: true });
        }
        return false;
      case AUTHORIZE_STATUS.AUTHORIZED:

      case AUTHORIZE_STATUS.EXPIRED:
        return true;
      default:
        return false;
    }
  };

  validLink = validLink => {
    const { requestActive } = this.props;
    if (validLink.expired || requestActive === false) this.props.setStatus(AUTHORIZE_STATUS.EXPIRED);
    else if (validLink.valid) this.props.setStatus(AUTHORIZE_STATUS.AUTHORIZED);
  };

  handleValidate = decryptKey => {
    const request = new MagicActionValidationRequest();
    request.decryptKey = decryptKey;
    request.actionKey = this.props.actionKey;
    this.props.validateLink(request);
  };
  handlePassCodeValidate = accessCode => {
    const request_validatepasscode = new PassCodeActionValidationRequest();
    request_validatepasscode.accessCode = accessCode;
    request_validatepasscode.actionKey = this.props.actionKey;
    request_validatepasscode.decryptKey = this.props.validLink.decryptKey;
    
    this.props.validatePassCode(request_validatepasscode);
  };
  setEmailValue = emailValue => {
    this.setState({ emailValue: emailValue });
    return false;
  };
  setErrorValue = validPassCode => {
    //return false;
    return validPassCode;
  };
  handleSendPassCode = () => {
    const request_sendpasscode = new MagicActionValidationRequest();
    request_sendpasscode.decryptKey = this.props.validLink.decryptKey;
    request_sendpasscode.actionKey = this.props.actionKey;
    this.props.sendPassCode(request_sendpasscode);
  };

  render() {
    const { ConfirmationCompleted, actionData, settings } = this.props;
    const { redirectNotFound } = this.state;

    if (ConfirmationCompleted && actionData.isSoftDeleted === false) {
      return <Redirect to="/completed" />;
    }
    if (actionData.isSoftDeleted === true) {
      return <Redirect to="/RFELinkExpired" />;
    }

    return (
      <React.Fragment>
        {redirectNotFound && <Redirect to="/" />}
        {this.state.stepComponent &&
          this.state.stepComponent.ActiveComponent({
            ...this.state.stepComponent.props,
            actionData: this.props.actionData,
            settings: settings
          })}
      </React.Fragment>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Authorize);
